import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export const AuthLayout = () => {
  return (
    <div className="flex flex-col h-screen">      
      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        <div className="h-full">
          <Suspense 
            fallback={
              <div className="flex justify-center items-center h-screen">
                <Loader2 className="h-8 w-8 text-gray-900 animate-spin" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;